import {
  addDoc,
  collection,
  doc,
  getDoc,
  getDocs,
  getFirestore,
  onSnapshot,
  query,
  setDoc,
  Timestamp,
  updateDoc,
  where,
} from "firebase/firestore";
import _ from "lodash";
import axios from "axios";
import Config, {
  CHAIN,
  INVENTORY_TYPE,
  PLOT_STATUS,
} from "../utils/constants/config";
import { app, firestoreInstance } from "../utils/utilities/firebase";
import algoliasearch from "algoliasearch";
import GeoJSON from "ol/format/GeoJSON";
import HELPER, {
  getDecriptionForEnvSig,
  getJSEncriptSignedData,
  getPubKeyForEnvSig,
} from "../utils/helpers/functions";
import CryptoJS from "crypto-js";
import { getSignedAddress } from "../web3";
import { fromHex, toBech32 } from "@cosmjs/encoding";

const REACT_APP_FIREBASE_VLAND_ENDPOINT =
  "virtua_prime/virtua_island/zones/monster/plots/";
const REACT_APP_FIREBASE_VLAND_BASE_ENDPOINT =
  "virtua_prime/virtua_island/zones/monster/";

let eternlUsedAddresses = [];

export const convertAddressToLowerCase = (address) => {
  return address?.toLowerCase();
};
export const getInvetoryItems = async (
  type,
  owner_id,
  chain,
  walletId = null,
  callBack
) => {
  const inventory = [];

  const db = firestoreInstance;
  owner_id = convertAddressToLowerCase(owner_id);
  const snapshots = [];

  const listener = (snapShot) => {
    snapShot?.docChanges().forEach((change) => {
      if (change?.type === "removed") {
        const removedPlot = change.doc.data();

        let index = inventory.findIndex((item) => {
          return (
            (removedPlot.plot_id && item.plot_id == removedPlot.plot_id) ||
            (removedPlot.id && item.id == removedPlot.id)
          );
        });

        if (index >= 0) {
          inventory.splice(index, 1);
        }
        callBack.setInventory(inventory);
      } else if (change?.type === "added") {
        const modifiedPlot = change.doc.data();

        let alreadyExist = _.find(
          inventory,
          (item) =>
            (modifiedPlot.plot_id && item.plot_id == modifiedPlot.plot_id) ||
            (modifiedPlot.id && modifiedPlot.id == item.id)
        );
        if (!alreadyExist && (modifiedPlot.plot_id || modifiedPlot.id)) {
          inventory.push(modifiedPlot);
          inventory?.sort(function (a, b) {
            return (b.updated_at ?? 0) - (a.updated_at ?? 0);
          });
          callBack.setInventory(inventory);
        }
      } else if (change?.type === "modified") {
        const modifiedPlot = change.doc.data();

        let index = inventory.findIndex((item) => {
          return (
            (modifiedPlot.plot_id && item.plot_id == modifiedPlot.plot_id) ||
            (modifiedPlot.id && item.id == modifiedPlot.id)
          );
        });

        if (index >= 0) {
          inventory[index] = modifiedPlot;
        }
        inventory?.sort(function (a, b) {
          return (b.updated_at ?? 0) - (a.updated_at ?? 0);
        });
        callBack.setInventory(inventory);
      }
    });
  };

  if (type == "all") {
    try {
      if (chain === "CARDANO" && walletId === "eternl") {
        let owner_addresses = await getEternlUsedAddresses();
        const splitAddresses = _.chunk(owner_addresses, 10);

        for (const address of splitAddresses) {
          const qPlot = query(
            collection(db, REACT_APP_FIREBASE_VLAND_BASE_ENDPOINT + "plots"),
            where("owner_id", "in", address),
            where("txHash", "!=", "")
          );
          snapshots.push(onSnapshot(qPlot, listener));
        }
      } else {
        const qPlot = query(
          collection(db, REACT_APP_FIREBASE_VLAND_BASE_ENDPOINT + "plots"),
          where("owner_id", "==", owner_id),
          where("txHash", "!=", "")
        );
        snapshots.push(onSnapshot(qPlot, listener));
      }
    } catch (ex) {
      console.log("ex===", ex);
    }
    try {
      const qCondo = query(
        collection(db, REACT_APP_FIREBASE_VLAND_BASE_ENDPOINT + "condos"),
        where("owner_id", "==", owner_id),
        where("txHash", "!=", "")
      );
      snapshots.push(onSnapshot(qCondo, listener));
    } catch (ex) {
      console.log("qCondo===", ex);
    }
  } else if (type == "processing") {
    try {
      if (chain === "CARDANO" && walletId === "eternl") {
        let owner_addresses = await getEternlUsedAddresses();
        const splitAddresses = _.chunk(owner_addresses, 10);

        for (const address of splitAddresses) {
          const qPlot = query(
            collection(db, REACT_APP_FIREBASE_VLAND_BASE_ENDPOINT + "plots"),
            where("owner_id", "in", address),
            where("status", "==", "PROCESSING"),
            where("txHash", "!=", "")
          );
          snapshots.push(onSnapshot(qPlot, listener));
        }
      } else {
        const qPlot = query(
          collection(db, REACT_APP_FIREBASE_VLAND_BASE_ENDPOINT + "plots"),
          where("owner_id", "==", owner_id),
          where("status", "==", "PROCESSING"),
          where("txHash", "!=", "")
        );
        snapshots.push(onSnapshot(qPlot, listener));
      }
    } catch (ex) {
      console.log("ex===", ex);
    }
    try {
      const qCondo = query(
        collection(db, REACT_APP_FIREBASE_VLAND_BASE_ENDPOINT + "condos"),
        where("owner_id", "==", owner_id),
        where("status", "==", "PROCESSING"),
        where("txHash", "!=", "")
      );
      snapshots.push(onSnapshot(qCondo, listener));
    } catch (ex) {
      console.log("qCondo===", ex);
    }
  } else {
    if (chain === "CARDANO" && walletId === "eternl") {
      let owner_addresses = await getEternlUsedAddresses();
      const splitAddresses = _.chunk(owner_addresses, 10);

      for (const address of splitAddresses) {
        const qPlot = query(
          collection(db, REACT_APP_FIREBASE_VLAND_BASE_ENDPOINT + "plots"),
          where("owner_id", "in", address),
          where("txHash", "!=", "")
        );
        snapshots.push(onSnapshot(qPlot, listener));
      }
    } else {
      const q = query(
        collection(db, REACT_APP_FIREBASE_VLAND_BASE_ENDPOINT + type),
        where("owner_id", "==", owner_id),
        where("txHash", "!=", "")
      );
      snapshots.push(onSnapshot(q, listener));
    }
  }
  callBack.setSnapShotArray(snapshots)
};
export const getDecriptedEnv = (envData) => {
  if (envData) {
    try {
      var bytes = CryptoJS.AES.decrypt(
        envData,
        getDecriptionForEnvSig(Config.ENV)
      );
      var decryptData = bytes.toString(CryptoJS.enc.Utf8);

      var decryptData = decryptData ? JSON.parse(decryptData) : {};

      return decryptData;
    } catch (error) {
      console.log("==>", error);
      return null;
    }
  }
  return null;
};
export const addEithItemDetailChangeListner = (plotID, type, listener) => {
  const db = firestoreInstance;
  const docRef = doc(
    collection(db, REACT_APP_FIREBASE_VLAND_BASE_ENDPOINT + type),
    plotID.toString()
  );
  return onSnapshot(docRef, listener);
};
export const addCardanoItemDetailChangeListner = (plotID, type, listener) => {
  const db = firestoreInstance;
  const docRef = doc(
    collection(db, REACT_APP_FIREBASE_VLAND_BASE_ENDPOINT + type),
    plotID.toString()
  );
  return onSnapshot(docRef, listener);
};
// export const getPlotDetailFireStore = async (plotID, type, chain) => {
//   const docRef = doc(
//     collection(db, REACT_APP_FIREBASE_VLAND_BASE_ENDPOINT + type),
//     plotID.toString()
//   );
//   const plotDetail = await getDoc(docRef);

//   return plotDetail?.data() ?? null;
// };

export const getConfigsFireStore = async () => {
  const db = firestoreInstance;
  const settingsDoc = doc(db, "/virtua_prime/virtua_island/zones", "monster");

  const settings = await getDoc(settingsDoc);
  return settings?.data() ?? null;
};

export const getEthStatingSlot = async () => {
  const db = firestoreInstance;
  const q = query(
    collection(db, "/virtua_prime/virtua_island/zones/monster/slots")
  );

  const querySnapshotSlots = await getDocs(q);

  let slots = [];
  querySnapshotSlots?.forEach((doc) => {
    slots.push(doc.data());
  });

  return slots.length > 0 ? slots[0] : null;
};

export const getCardanoStatingSlot = async () => {
  const db = firestoreInstance;
  const q = query(
    collection(db, "/virtua_prime/virtua_island/zones/monster/cardano_slots")
  );

  const querySnapshotSlots = await getDocs(q);

  let slots = [];
  querySnapshotSlots?.forEach((doc) => {
    slots.push(doc.data());
  });

  return slots.length > 0 ? slots[0] : null;
};
export const updatePlotStatus = async (
  plotId,
  status,
  inventoryType,
  account,
  txHash,
  cardanoWalletId = ""
) => {
  const db = firestoreInstance;
  account = convertAddressToLowerCase(account);
  const plotRef = collection(
    db,
    REACT_APP_FIREBASE_VLAND_BASE_ENDPOINT + inventoryType
  );
  try {
    if (txHash) {
      await setDoc(
        doc(plotRef, plotId?.toString()),
        {
          status: status.toUpperCase(),
          owner_id: account,
          txHash: txHash,
          wallet_provider:cardanoWalletId
        },
        { merge: true }
      );
    } else {
      await setDoc(
        doc(plotRef, plotId?.toString()),
        {
          status: status.toUpperCase(),
          owner_id: account,
        },
        { merge: true }
      );
    }

    return true;
  } catch (error) {
    return false;
  }
};
export const updateAndLockPlot = async (plotId, inventoryType, account) => {
  const db = firestoreInstance;
  account = convertAddressToLowerCase(account);
  const plotRef = collection(
    db,
    REACT_APP_FIREBASE_VLAND_BASE_ENDPOINT + inventoryType
  );
  const currentTime = new Date().getTime();

  try {
    const updateResult = await setDoc(
      doc(plotRef, plotId?.toString()),
      {
        status: PLOT_STATUS.LOCKED,
        updated_at: currentTime,
        owner_id: account,
      },
      { merge: true }
    );
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export const addCondoTransaction = async (
  condoID,
  status,
  account,
  txHash,
  condoDetail
) => {
  const db = firestoreInstance;
  let conodObject = { ...condoDetail };
  conodObject.status = status.toUpperCase();
  conodObject.owner_id = convertAddressToLowerCase(account);
  conodObject.updated_at = new Date().getTime();
  conodObject.created_at = new Date().getTime();
  delete conodObject.signature;

  if (txHash) {
    conodObject.txHash = txHash;
  }
  try {
    const transactionRef = collection(
      db,
      "/virtua_prime/virtua_island/zones/monster/condo_transactions"
    );

    await setDoc(doc(transactionRef, condoID?.toString()), conodObject, {
      merge: true,
    });

    return true;
  } catch (error) {
    console.log("CondoError==>>", error);
    return false;
  }
};

export const updateCondoStatus = async (
  condoID,
  status,
  inventoryType,
  account,
  txHash
) => {
  const db = firestoreInstance;
  const plotRef = collection(
    db,
    REACT_APP_FIREBASE_VLAND_BASE_ENDPOINT + inventoryType
  );
  try {
    if (txHash) {
      await setDoc(
        doc(plotRef, condoID?.toString()),
        {
          status: status.toUpperCase(),
          owner_id: convertAddressToLowerCase(account),
          txHash: txHash,
          updated_at: new Date().getTime(),
        },
        { merge: true }
      );
    } else {
      await setDoc(
        doc(plotRef, condoID?.toString()),
        {
          status: status.toUpperCase(),
          owner_id: convertAddressToLowerCase(account),
          updated_at: new Date().getTime(),
        },
        { merge: true }
      );
    }
    return true;
  } catch (error) {
    console.log("CondoError==>>", error);
    return false;
  }
};

export const updateAndUnlockPlot = async (
  plotID,
  inventoryType,
  account,
  chain
) => {
  const db = firestoreInstance;
  try {
    const docRef = doc(
      collection(db, REACT_APP_FIREBASE_VLAND_BASE_ENDPOINT + inventoryType),
      plotID.toString()
    );
    const plotDetail = await getDoc(docRef);

    if (chain === CHAIN.EITH) {
      if (plotDetail?.data()?.owner_id == convertAddressToLowerCase(account)) {
        updateDoc(plotDetail.ref, {
          status: "AVAILABLE",
          updated_at: new Date().getTime(),
          owner_id: "0X0000000000000000",
        });
      }
    } else if (chain === CHAIN.CARDANO) {
      if (plotDetail?.data()?.owner_id == account) {
        updateDoc(plotDetail.ref, {
          status: "AVAILABLE",
          updated_at: new Date().getTime(),
          owner_id: "0X0000000000000000",
        });
      }
    }
  } catch (error) {
    console.log("updateAndUnlockPlot==>", error);
  }
};

export const getPreviousLockedPlots = async (
  inventoryType,
  account,
  chain,
  walletId = null
) => {
  const db = firestoreInstance;
  try {
    const lockedPlots = [];

    if (chain === "CARDANO" && walletId === "eternl") {
      let owner_addresses = await getEternlUsedAddresses();
      const splitAddresses = _.chunk(owner_addresses, 10);

      for (const address of splitAddresses) {
        const q = query(
          collection(
            db,
            REACT_APP_FIREBASE_VLAND_BASE_ENDPOINT + inventoryType
          ),
          where("owner_id", "in", address),
          where("status", "==", PLOT_STATUS.LOCKED),
          where("blockchain", "==", chain)
        );

        const querySnapshot = await getDocs(q);
        querySnapshot?.forEach((doc) => {
          lockedPlots.push(doc.data());
        });
      }
    } else {
      const q = query(
        collection(db, REACT_APP_FIREBASE_VLAND_BASE_ENDPOINT + inventoryType),
        where(
          "owner_id",
          "==",
          chain == CHAIN.EITH ? convertAddressToLowerCase(account) : account
        ),
        where("status", "==", PLOT_STATUS.LOCKED),
        where("blockchain", "==", chain)
      );

      const querySnapshot = await getDocs(q);

      querySnapshot?.forEach((doc) => {
        lockedPlots.push(doc.data());
      });
    }
    return lockedPlots;
  } catch (error) {
    console.log("lockedPlots::", error);
    return null;
  }
};

export const getAndReleaseLockedCondo = async (
  account,
  eithAuthToken,
  keysPassed
) => {
  const db = firestoreInstance;
  try {
    const lockedCondo = [];
    const q = query(
      collection(db, REACT_APP_FIREBASE_VLAND_BASE_ENDPOINT + "condos"),
      where("owner_id", "==", convertAddressToLowerCase(account)),
      where("status", "==", PLOT_STATUS.LOCKED),
      where("txHash", "==", "")
    );

    const querySnapshot = await getDocs(q);

    querySnapshot?.forEach((doc) => {
      lockedCondo.push(doc.data());
    });

    if (lockedCondo.length > 0) {
      lockedCondo.map((item) => {
        releaseCondo(account, eithAuthToken, item.id, keysPassed);
      });
    }
  } catch (error) {
    console.log("lockedCondo::", error);
  }
};
export const getEithPlotsData = async () => {
  const db = firestoreInstance;
  const q = query(
    collection(db, REACT_APP_FIREBASE_VLAND_ENDPOINT),
    where("blockchain", "==", "ETH")
  );
  return await getDocs(q);
};

export const getCardanoPlotsData = async () => {
  const db = firestoreInstance;
  const q = query(
    collection(db, REACT_APP_FIREBASE_VLAND_ENDPOINT),
    where("blockchain", "==", "CARDANO")
  );
  return await getDocs(q);
};

export const getEithProcessingPlotsData = async (owner_id) => {
  const db = firestoreInstance;
  try {
    owner_id = convertAddressToLowerCase(owner_id);
    const qPlot = query(
      collection(db, REACT_APP_FIREBASE_VLAND_BASE_ENDPOINT + "plots"),
      where("owner_id", "==", owner_id),
      where("status", "==", "PROCESSING"),
      where("txHash", "!=", "")
    );
    let plotsArray = [];

    const querySnapshotPlots = await getDocs(qPlot);

    querySnapshotPlots?.forEach((doc) => {
      plotsArray.push(doc.data());
    });

    const qCondo = query(
      collection(db, REACT_APP_FIREBASE_VLAND_BASE_ENDPOINT + "condos"),
      where("owner_id", "==", owner_id),
      where("status", "==", "PROCESSING"),
      where("txHash", "!=", "")
    );

    const querySnapshotCondo = await getDocs(qCondo);

    querySnapshotCondo?.forEach((doc) => {
      plotsArray.push(doc.data());
    });

    plotsArray?.sort(function (a, b) {
      return (b.updated_at ?? 0) - (a.updated_at ?? 0);
    });
    return plotsArray;
  } catch (error) {
    console.log("getEithProcessingPlotsData:", error);
    return [];
  }
};

export const addEithPlotChangeListner = (listener) => {
  const db = firestoreInstance;
  const q = query(
    collection(db, REACT_APP_FIREBASE_VLAND_ENDPOINT),
    where("blockchain", "==", "ETH")
  );
  return onSnapshot(q, listener);
};

export const addCardanoPlotChangeListner = (listener) => {
  const db = firestoreInstance;
  const q = query(
    collection(db, REACT_APP_FIREBASE_VLAND_ENDPOINT),
    where("blockchain", "==", "CARDANO")
  );
  return onSnapshot(q, listener);
};

export const addEithPlotChangeListnerForAddress = (owner_id, listener) => {
  const db = firestoreInstance;
  owner_id = convertAddressToLowerCase(owner_id);
  const plots = query(
    collection(db, REACT_APP_FIREBASE_VLAND_ENDPOINT),
    where("owner_id", "==", owner_id),
    where("txHash", "!=", "")
  );
  const condos = query(
    collection(db, REACT_APP_FIREBASE_VLAND_BASE_ENDPOINT + "condos"),
    where("owner_id", "==", owner_id),
    where("txHash", "!=", "")
  );
  const snapshots = [];
  snapshots.push(onSnapshot(plots, listener));
  snapshots.push(onSnapshot(condos, listener));
  return snapshots;
};
export const addEithCondoChangeListnerForAddress = (owner_id, listener) => {
  const db = firestoreInstance;
  const q = query(
    collection(db, REACT_APP_FIREBASE_VLAND_BASE_ENDPOINT + "condos"),
    where("owner_id", "==", convertAddressToLowerCase(owner_id)),
    where("txHash", "!=", "")
  );
  return onSnapshot(q, listener);
};
export const getPlotsFeaturesData = (chain = CHAIN.EITH, keys, callBack) => {
  keys = getDecriptedEnv(keys);
  const algoliaClient = algoliasearch(
    keys.algolia_app_id,
    keys.algolia_app_secret
  );
  const plotsIndex = algoliaClient.initIndex(keys.algolia_index);
  let plotsData = [];
  plotsIndex
    .browseObjects({
      query: "",
      // attributesToRetrieve: [
      //   "id",
      //   "blockchain",
      //   "plot_id",
      //   "size",
      //   "plot_name",
      //   "status",
      //   "owner_id",
      //   "loc_right",
      //   "loc_left",
      //   "loc_top",
      //   "loc_bottom",
      //   "color_code",
      //   "image"
      //   "image",
      //   "rarity"
      // ],

      batch: (batch) => {
        plotsData = plotsData.concat(batch);
      },
    })
    .then(() => {
      new Promise((resolve) => {
        const features = [];

        let plotsFilteredData = [];
        plotsData.map((item) => {
          if (item.blockchain == chain) {
            plotsFilteredData.push(item);
            const colorValue = HELPER.getColorByStatus(item);
            features.push({
              id: item.plot_id,
              type: "Feature",
              geometry: {
                type: "Polygon",
                coordinates: [
                  [
                    [item.loc_left[0], item.loc_left[1]],
                    [item.loc_right[0], item.loc_right[1]],
                    [item.loc_top[0], item.loc_top[1]],
                    [item.loc_bottom[0], item.loc_bottom[1]],
                  ],
                ],
              },
              properties: {
                plot_type: item.plot_type,
                plot_id: item.plot_id,
                size: item.size,
                color: colorValue,
                type: INVENTORY_TYPE.PLOT,
              },
            });
          }
        });

        features.push({
          id: -1000000,

          type: "Feature",
          geometry: {
            type: "Polygon",

            coordinates: [
              [
                [16.100998028199076, 21.786684779783357],
                [16.233204400028345, 21.843023215009964],
                [16.25491269850214, 21.79584518508162],
                [16.121770525853105, 21.737043884269465],
              ],
            ],
          },
          properties: {
            color: null,
            type: INVENTORY_TYPE.CONDO,
          },
        });
        const geoData = new GeoJSON().readFeatures({
          type: "FeatureCollection",
          features: features,
        });

        resolve([geoData, plotsFilteredData]);
      })
        .then((res) => {
          callBack(res[0], res[1]);
        })
        .catch((ex) => {
          callBack(null, plotsData);
        });
    })
    .catch((ex) => {
      console.log("ress===>>", ex);
      callBack(null, plotsData);
    });
};

export const getWhiteListStatus = async (address, token, keys) => {
  try {
    const signedAddess = await getSignedAddress(
      keys,
      convertAddressToLowerCase(address)
    );

    if (!signedAddess) throw false;

    let response = await axios.post(
      process.env.REACT_APP_API_URL_FEATURED + "condo-whitelist",
      {
        signature: signedAddess,
      },
      {
        headers: {
          Authorization: token,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.log("error:", error);
    return error?.response?.data ?? { status: false };
  }
};

export const getCardanoWhiteListStatus = async (
  address,
  walletId = null,
  usedAddresses = []
) => {
  try {
    const key = getAppSignatureKey();
    const data = {
      walletAddress: address,
      action: "CARDANO",
    };

    const signedData = await getJSEncriptSignedData(key, JSON.stringify(data));

    if (!signedData) throw false;

    let response = await axios.post(
      process.env.REACT_APP_API_URL_FEATURED + "get-slots",
      {
        data: signedData,
        wallet_id: walletId,
        addresses: usedAddresses,
      }
    );
    return response.data;
  } catch (error) {
    console.log("error:", error);
    return error?.response?.data ?? { status: false };
  }
};
export const getCardanoMintLand = async (
  wallet,
  landId,
  cardanoWalletId,
  utxos
) => {
  try {
    const key = getAppSignatureKey();
    const data = {
      plot_id: landId?.toString() ?? "",
      changeAddress: wallet,
      wallet_id: cardanoWalletId,
    };

    const signedData = await getJSEncriptSignedData(key, JSON.stringify(data));
    if (!signedData) throw false;

    let response = await axios.post(
      process.env.REACT_APP_API_URL_FEATURED + "cardano-mint-land",
      {
        data: signedData,
        utxos: utxos,
      }
    );
    return response ? response.data.payload : null;
  } catch (error) {
    console.log(error?.response?.data);
    throw {
      status: false,
      message: error?.response?.data?.message,
    };
    // return error?.response?.data ?? { status: false };
  }
};

export const getRandomCondo = async (address, token, keys) => {
  // try {

  const signedAddess = await getSignedAddress(
    keys,
    convertAddressToLowerCase(address)
  );

  if (!signedAddess) throw false;

  let response = await axios.post(
    process.env.REACT_APP_API_URL_FEATURED + "get-condo-web",
    {
      signature: signedAddess,
    },
    {
      headers: {
        Authorization: token,
      },
    }
  );

  return response.data;
  // } catch (error) {
  //   console.log("error:", error);
  //   return error?.response?.data ?? { status: false };
  // }
};

export const releaseCondo = async (address, token, condoId, keys) => {
  try {
    const signedAddess = await getSignedAddress(
      keys,
      convertAddressToLowerCase(address)
    );

    if (!signedAddess) throw false;

    let response = await axios.post(
      process.env.REACT_APP_API_URL_FEATURED + "condo-release",
      {
        signature: signedAddess,
        condoId: condoId,
      },
      {
        headers: {
          Authorization: token,
          platform: "web",
          build: 1.0,
          version: 1.0,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.log("error:", error);
    return error?.response?.data ?? { status: false };
  }
};
export const createToUserProfile = async (user, address) => {
  const db = firestoreInstance;
  const docData = {
    uid: user?.uid,
    wallet_address: convertAddressToLowerCase(address),
  };

  await setDoc(doc(db, "user_profile", user.uid), docData);
};
export const getAppSignatureKey = () => {
  const key =
    "-----BEGIN PUBLIC KEY-----" +
    getPubKeyForEnvSig(Config.ENV) +
    "-----END PUBLIC KEY-----\n";

  return key;
};

const getAppConfigSignature = () => {
  const key = getAppSignatureKey();

  return getJSEncriptSignedData(key, "monsterzone");
};

export const getAppConfigs = async () => {
  try {
    let response = await axios.get(
      process.env.REACT_APP_API_URL_FEATURED + "monster-zone-configuration",
      {
        headers: {
          Authorization: getAppConfigSignature(),
        },
      }
    );

    return response.data?.payload;
  } catch (error) {
    console.log("error:", error);
    return error?.response?.data ?? { status: false };
  }
};

export const hexToBech32 = (addresses) => {
  for (const addr of addresses) {
    const hexAddr = toBech32("addr", fromHex(addr), 1000);
    eternlUsedAddresses.push(hexAddr);
  }
};

export const getEternlUsedAddresses = async () => {
  if (eternlUsedAddresses.length < 1) {
    let wallet = await window.cardano.eternl.enable();

    let addresses = await wallet.getUsedAddresses();
    await hexToBech32(addresses);

    try {
      let currentAddre = toBech32(
        "addr",
        fromHex(await wallet.getChangeAddress()),
        1000
      );
      let alreadyExist = _.find(
        eternlUsedAddresses ?? [],
        (item) => item == currentAddre
      );

      if (!alreadyExist) eternlUsedAddresses.push(currentAddre);
    } catch (error) {}
    
  }

  return eternlUsedAddresses;
};
